module.exports = __webpack_public_path__ + "static/media/invoice.769b05d9.svg";